import {IHttpService} from "angular";
import {BrokerageEstimationRequest} from "../types/BrokerageEstimationRequest";

export class BrokerageEstimationService {

    public static readonly id = "brokerageEstimationService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async estimate(portfolioId: number, order: BrokerageEstimationRequest): Promise<number> {
        const url =  `/tradefloor/api/portfolio/${portfolioId}/ticket/brokerage-estimate`;
        const response = await this.$http.post<number>(url, order);
        return response.data;
    }
}
